export default import.meta.ROLLDOWN_FILE_URL_lDbjsedF7QutsjelctGeuQ